import { Locale } from "../lib/locale";
import { LanguageName } from "../lib/country";

export const langNameMap: Record<Locale, LanguageName> = {
  "pt-BR": "NAME_PT",
  "es-MX": "NAME_ES",
  "en-CA": "NAME_EN",
  "fr-FR": "NAME_FR",
  "de-DE": "NAME_DE",
  "hu-HU": "NAME_HU",
  "pl-PL": "NAME_PL",
  "it-IT": "NAME_IT",
  "sv-SE": "NAME_SV",
};
